// class MetafieldDrawerButton extends HTMLButtonElement {
//   constructor() {
//     super();
//     this.addEventListener("click", this.onButtonsClick.bind(this));
//     console.log("This is the button click" + this);
//     // const attributeValue = this.getAttribute("data-content-id");
//     // console.log("Test" + attributeValue);
//   }

//   onButtonsClick() {
//     const contentId = this.getAttribute('data-content-id');
//     const drawerId = this.getAttribute('aria-controls');
//     const drawer = document.getElementById(drawerId);var drawer = document.querySelectorAll('.drawer-content-item[data-content-id="content_cushioning"]');
//     console.log(drawer);
    
//     const attributeValue = this.getAttribute('data-content-id');
//     console.log("Tests: " + this.getAttribute('data-content-id'));
//     if (drawer) {
//       const contentId = this.getAttribute('data-content-id');
//       console.log(drawer.srcElement);
//       console.log('ID' + contentId);
//       // First, show the main drawer content
//       const mainContent = drawer.querySelector('.drawer__content');
//       if (mainContent) {
//         mainContent.style.display = 'block';
//       }

//       // Then handle the specific content items
//       const contentItems = drawer.querySelectorAll('.drawer-content-item[id]');
//       contentItems.forEach(content => {
//         content.style.display = content.id === contentId ? 'block' : 'none';
//       });
      
//       drawer.open = true;
//       this.setAttribute('aria-expanded', 'true');
//     }
//   }
// }
// customElements.define('toggle-button', MetafieldDrawerButton, { extends: 'button' });

// Use a more specific name to avoid conflicts
// customElements.define('metafield-drawer-button', MetafieldDrawerButton, { extends: 'button' });

document.addEventListener('DOMContentLoaded', () => {

  console.log("Ready");

  let btns = document.getElementsByClassName("product-meta__help");
  console.log(btns);
  for(var i = 0; i < btns.length; i++){
    console.log(btns[i]);
    btns[i].onclick = function(){

      var drawers = document.getElementsByClassName("drawer-content-item");

      for(var j = 0; j < drawers.length; j++){
        console.log(drawers[j]);
        drawers[j].style.display = "none";
      }

      document.getElementById("drawer_items_container").style.display = "block";
      
      console.log("clicked drawer button");
      console.log(this.getAttribute("data-content-id"));
      document.getElementById(this.getAttribute("data-content-id")).style.display = "block";
      console.log("Correct item ",this.getAttribute("data-content-id"));
      
    }
  }
  
  const drawers = document.querySelectorAll('drawer-content');
  drawers.forEach(drawer => {
    drawer.addEventListener('click', (event) => {
      if (event.target.closest('[data-action="close"]')) {
        drawer.open = false;
        // Find and update the associated button
        const buttonId = drawer.id;
        const associatedButton = document.querySelector(`button[aria-controls="${buttonId}"]`);
        if (associatedButton) {
          associatedButton.setAttribute('aria-expanded', 'false');
        }
      }
    });
  });
});